module.exports = __webpack_public_path__ + "img/thumbnail-marquee-calyrafit.3970fb54.webp";